import cn from 'classnames';
import React, { lazy } from 'react';
import { useWidget } from 'state/widget/context';
import HeaderTitle from './HeaderTitle';
import styles from './WidgetHeader.module.scss';
const DiscoLogo = lazy(() => import('components/DiscoLogo/DiscoLogo'));

export interface WidgetHeaderProps {
  className?: string;
  icon?: React.ReactNode;
  logo?: React.ComponentType<{ className: string }>;
  titleOverride?: string;
  titleClassName?: string;
  divider?: React.ReactNode;
  titleLinkDestination?: string;
}

const WidgetHeader = React.forwardRef<HTMLDivElement, WidgetHeaderProps>(
  (
    {
      className,
      icon,
      logo,
      titleOverride,
      titleClassName,
      divider,
      titleLinkDestination,
    },
    ref,
  ) => {
    const {
      state: { showLogo, brandingLogo, title: defaultTitle },
    } = useWidget();

    const Logo = logo === undefined ? DiscoLogo : logo;
    const title = titleOverride || defaultTitle;

    return (
      <div className={cn(styles.root, className)} ref={ref}>
        <div className={styles.contents}>
          {icon && <span className={styles.icon}>{icon}</span>}
          <HeaderTitle
            titleClassName={titleClassName}
            title={title}
            href={titleLinkDestination}
          />
          {showLogo && (
            <Logo brandingLogo={brandingLogo} className={styles.logo} />
          )}
        </div>

        {divider !== undefined ? divider : <div className={styles.divider} />}
      </div>
    );
  },
);
export default WidgetHeader;
